import React, { FunctionComponent, useEffect, useState } from 'react'
import { Select, Space, Typography } from 'antd'

import { Brand, Channel } from '../../../context/types'

const { Paragraph } = Typography
const { Option } = Select

interface ChannelSelectProps {
	brands: Brand[]
	channels: Channel[]
	onChange: (channel: Channel) => void
}

const ChannelSelect: FunctionComponent<ChannelSelectProps> = (props) => {
	const { brands, channels, onChange } = props

	const [brand, setBrand] = useState<Brand>(brands[0])
	const [channel, setChannel] = useState<Channel>()

	const brandChannels = channels.filter((v) => v.brand.id === brand?.id)
	const channelIndex = brandChannels.findIndex((v) => v.id === channel?.id)

	useEffect(() => {
		if (!brand) setBrand(brands[0])

		const nextChannel = channels.find((v) => v.brand.id === brand?.id)
		setChannel(nextChannel)
	}, [brand, channels, brands])

	useEffect(() => {
		onChange(channel)
	}, [channel, onChange])

	return (
		<Space>
			<section>
				<Paragraph>Brand</Paragraph>
				<Select
					disabled={!brands.length}
					style={{ width: 200 }}
					defaultValue={0}
					placeholder="Select a brand"
					onSelect={(v: number) => setBrand(brands[v])}
				>
					{brands.map((v, i) => (
						<Option key={v.id} value={i}>
							{v.name}
						</Option>
					))}
				</Select>
			</section>

			<section>
				<Paragraph>Channel</Paragraph>
				<Select
					value={channelIndex > -1 ? channelIndex : undefined}
					disabled={!brandChannels.length}
					style={{ width: 200 }}
					placeholder="Select a brand"
					onSelect={(v: number) => setChannel(brandChannels[v])}
				>
					{brandChannels.map((v, i) => (
						<Option key={v.id} value={i}>
							{v.name}
						</Option>
					))}
				</Select>
			</section>
		</Space>
	)
}

export default ChannelSelect
